import script from "./AppDivider.vue?vue&type=script&lang=js"
export * from "./AppDivider.vue?vue&type=script&lang=js"

import "./AppDivider.vue?vue&type=style&index=0&id=1fbec07f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fbec07f"]])

export default __exports__